import { Christmas } from 'PARTIALS/christmas';
import { ww } from 'bobjoll/ts/library/dom';

ww.Christmas = new Christmas();
